<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#3F033B"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#3F033B" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">{{ msg }}</span>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs9 text-left pb-2>
        <span class="mainHeader">KARIGAR JOBS</span>
      </v-flex>
      <v-flex xs3 text-right>
        <v-btn dark color="#3F053C" @click="openSendDialog()">Send Item</v-btn>
      </v-flex>
      <v-flex xs12 py-6 text-left>
        <v-card class="rounded-lg" elevation="0" color="#FFFFFF">
          <v-layout wrap pa-4 v-if="jobList.length > 0">
            <v-flex xs12>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Karigar</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Item</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Purpose</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Sent (gm)</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Received (gm)</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Wastage (gm)</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Status</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Action</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, i) in jobList" :key="i" class="table">
                      <td>{{ value.karigarId ? value.karigarId.karigarName : "-" }}</td>
                      <td>
                        <span v-if="value.purchaseItemId && value.purchaseItemId.designId">{{ value.purchaseItemId.designId.name }}</span>
                        <span v-else>{{ value.itemDescription || "-" }}</span>
                      </td>
                      <td>{{ value.purpose }}</td>
                      <td>{{ value.sentWeight }}</td>
                      <td>{{ value.receivedWeight || "-" }}</td>
                      <td>{{ value.wastageWeight || "-" }}</td>
                      <td>{{ value.status }}</td>
                      <td>
                        <v-btn v-if="value.status == 'Sent'" x-small color="#3F053C" dark @click="openReceiveDialog(value)">Receive</v-btn>
                        <v-btn v-if="value.status == 'Received'" x-small color="#3F053C" dark @click="openSettleDialog(value)">Settle Wastage</v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout wrap pa-4 v-else>
            <v-flex xs12 text-center>No karigar jobs yet.</v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog width="500px" v-model="sendDialog">
      <v-card width="500px" class="pa-4">
        <span style="color: #3f053c; font-size: 20px">Send Item to Karigar</span>
        <v-layout wrap pt-4>
          <v-flex xs12 pb-2>
            <v-select v-model="newJob.karigarId" :items="karigarList" item-text="karigarName" item-value="_id" outlined dense label="Karigar" hide-details></v-select>
          </v-flex>
          <v-flex xs12 pb-2>
            <v-select v-model="newJob.purpose" :items="['Repair', 'Custom Order', 'Polishing', 'Resizing']" outlined dense label="Purpose" hide-details></v-select>
          </v-flex>
          <v-flex xs12 pb-2>
            <v-text-field v-model="newJob.itemDescription" outlined dense label="Item Description" hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 pb-2>
            <v-text-field v-model="newJob.sentWeight" type="number" outlined dense label="Weight Sent (gm)" hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 pb-2>
            <v-text-field v-model="newJob.expectedReturnDate" type="date" outlined dense label="Expected Return Date" hide-details></v-text-field>
          </v-flex>
        </v-layout>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="sendDialog = false">Cancel</v-btn>
          <v-btn color="#3F053C" dark @click="sendItem()">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="400px" v-model="receiveDialog">
      <v-card width="400px" class="pa-4" v-if="curJob">
        <span style="color: #3f053c; font-size: 20px">Mark Item Received</span>
        <v-layout wrap pt-4>
          <v-flex xs12 pb-2 class="tablefont">Weight sent: {{ curJob.sentWeight }}gm</v-flex>
          <v-flex xs12 pb-2>
            <v-text-field v-model="receiveForm.receivedWeight" type="number" outlined dense label="Weight Received (gm)" hide-details></v-text-field>
          </v-flex>
        </v-layout>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="receiveDialog = false">Cancel</v-btn>
          <v-btn color="#3F053C" dark @click="markReceived()">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="400px" v-model="settleDialog">
      <v-card width="400px" class="pa-4" v-if="curJob">
        <span style="color: #3f053c; font-size: 20px">Settle Wastage</span>
        <v-layout wrap pt-4>
          <v-flex xs12 pb-2 class="tablefont">Wastage: {{ curJob.wastageWeight }}gm</v-flex>
          <v-flex xs12 pb-2>
            <v-text-field v-model="settleForm.wastageSettledAmount" type="number" outlined dense label="Settled Amount (₹)" hide-details></v-text-field>
          </v-flex>
        </v-layout>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="settleDialog = false">Cancel</v-btn>
          <v-btn color="#3F053C" dark @click="settleWastage()">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 2000,
      msg: null,
      jobList: [],
      karigarList: [],
      sendDialog: false,
      receiveDialog: false,
      settleDialog: false,
      curJob: null,
      newJob: {
        karigarId: null,
        purpose: "Repair",
        itemDescription: null,
        sentWeight: null,
        expectedReturnDate: null,
      },
      receiveForm: { receivedWeight: null },
      settleForm: { wastageSettledAmount: null },
    };
  },
  mounted() {
    this.getJobList();
    this.getKarigarList();
  },
  methods: {
    getJobList() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/karigarjob/getlist",
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.jobList = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getKarigarList() {
      axios({
        method: "get",
        url: "/karigar/getlist",
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.karigarList = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openSendDialog() {
      this.newJob = { karigarId: null, purpose: "Repair", itemDescription: null, sentWeight: null, expectedReturnDate: null };
      this.sendDialog = true;
    },
    sendItem() {
      axios({
        method: "post",
        url: "/karigarjob/add",
        headers: { "x-auth-token": localStorage.getItem("token") },
        data: this.newJob,
      })
        .then((response) => {
          this.msg = response.data.msg;
          this.showsnackbar = true;
          if (response.data.status == true) {
            this.sendDialog = false;
            this.getJobList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openReceiveDialog(job) {
      this.curJob = job;
      this.receiveForm = { receivedWeight: null };
      this.receiveDialog = true;
    },
    markReceived() {
      axios({
        method: "post",
        url: "/karigarjob/receive",
        headers: { "x-auth-token": localStorage.getItem("token") },
        data: { id: this.curJob._id, receivedWeight: this.receiveForm.receivedWeight },
      })
        .then((response) => {
          this.msg = response.data.msg;
          this.showsnackbar = true;
          if (response.data.status == true) {
            this.receiveDialog = false;
            this.getJobList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openSettleDialog(job) {
      this.curJob = job;
      this.settleForm = { wastageSettledAmount: null };
      this.settleDialog = true;
    },
    settleWastage() {
      axios({
        method: "post",
        url: "/karigarjob/settle",
        headers: { "x-auth-token": localStorage.getItem("token") },
        data: { id: this.curJob._id, wastageSettledAmount: this.settleForm.wastageSettledAmount },
      })
        .then((response) => {
          this.msg = response.data.msg;
          this.showsnackbar = true;
          if (response.data.status == true) {
            this.settleDialog = false;
            this.getJobList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
